"use client";

import { c as _c } from "react/compiler-runtime";
import type { OptionType, Variant } from "@spree/sdk";
import { useTranslations } from "next-intl";
import { useMemo } from "react";
import { Button } from "@/components/ui/button";
interface VariantPickerProps {
  variants: Variant[];
  optionTypes: OptionType[];
  selectedVariant: Variant | null;
  onVariantChange: (variant: Variant | null) => void;
}
export function VariantPicker(t0) {
  const $ = _c(51);
  const {
    variants,
    optionTypes,
    selectedVariant,
    onVariantChange
  } = t0;
  const t = useTranslations("products");
  let map;
  if ($[0] !== optionTypes || $[1] !== variants) {
    map = {};
    optionTypes.forEach(optionType => {
      map[optionType.id] = new Set();
    });
    variants.forEach(variant => {
      variant.option_values.forEach(optionValue => {
        if (map[optionValue.option_type_id]) {
          map[optionValue.option_type_id].add(optionValue.name);
        }
      });
    });
    $[0] = optionTypes;
    $[1] = variants;
    $[2] = map;
  } else {
    map = $[2];
  }
  const optionValuesMap = map;
  let options;
  if ($[3] !== selectedVariant) {
    options = {};
    if (selectedVariant) {
      selectedVariant.option_values.forEach(ov => {
        options[ov.option_type_id] = ov.name;
      });
    }
    $[3] = selectedVariant;
    $[4] = options;
  } else {
    options = $[4];
  }
  const selectedOptions = options;
  let t1;
  if ($[5] !== variants) {
    t1 = variants.map(_temp);
    $[5] = variants;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const maps = t1;
  let detailsMap;
  if ($[7] !== variants) {
    detailsMap = {};
    for (const variant_1 of variants) {
      for (const ov_1 of variant_1.option_values) {
        const key = `${ov_1.option_type_id}:${ov_1.name}`;
        if (!detailsMap[key]) {
          detailsMap[key] = ov_1;
        }
      }
    }
    $[7] = variants;
    $[8] = detailsMap;
  } else {
    detailsMap = $[8];
  }
  let t2;
  if ($[9] !== detailsMap || $[10] !== maps) {
    t2 = {
      variantOptionMaps: maps,
      optionValueDetailsMap: detailsMap
    };
    $[9] = detailsMap;
    $[10] = maps;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  const {
    variantOptionMaps,
    optionValueDetailsMap
  } = t2;
  let t3;
  if ($[12] !== variantOptionMaps) {
    t3 = newOptions => {
      const optionCount = Object.keys(newOptions).length;
      return variantOptionMaps.find(t4 => {
        const {
          variant: variant_2,
          optionsMap: optionsMap_0
        } = t4;
        return variant_2.option_values.length === optionCount && Object.entries(newOptions).every(t5 => {
          const [typeId, value] = t5;
          return optionsMap_0[typeId] === value;
        });
      })?.variant || null;
    };
    $[12] = variantOptionMaps;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  const findVariant = t3;
  let available;
  let purchasable;
  if ($[14] !== optionValuesMap || $[15] !== selectedOptions || $[16] !== variantOptionMaps) {
    available = new Set();
    purchasable = new Set();
    for (const [optionTypeId, values] of Object.entries(optionValuesMap)) {
      for (const optionValue_0 of values) {
        const testOptions = {
          ...selectedOptions,
          [optionTypeId]: optionValue_0
        };
        const matches = variantOptionMaps.filter(t4 => {
          const {
            optionsMap: optionsMap_1
          } = t4;
          return Object.entries(testOptions).every(t5 => {
            const [typeId_0, value_0] = t5;
            return optionsMap_1[typeId_0] === value_0;
          });
        });
        const key_0 = `${optionTypeId}:${optionValue_0}`;
        if (matches.length > 0) {
          available.add(key_0);
        }
        if (matches.some(_temp2)) {
          purchasable.add(key_0);
        }
      }
    }
    $[14] = optionValuesMap;
    $[15] = selectedOptions;
    $[16] = variantOptionMaps;
    $[17] = available;
    $[18] = purchasable;
  } else {
    available = $[17];
    purchasable = $[18];
  }
  let t4;
  if ($[19] !== available || $[20] !== purchasable) {
    t4 = {
      availableOptions: available,
      purchasableOptions: purchasable
    };
    $[19] = available;
    $[20] = purchasable;
    $[21] = t4;
  } else {
    t4 = $[21];
  }
  const {
    availableOptions,
    purchasableOptions
  } = t4;
  let t5;
  if ($[22] !== availableOptions) {
    t5 = (optionTypeId_0, optionValue_1) => availableOptions.has(`${optionTypeId_0}:${optionValue_1}`);
    $[22] = availableOptions;
    $[23] = t5;
  } else {
    t5 = $[23];
  }
  const isOptionAvailable = t5;
  let t6;
  if ($[24] !== purchasableOptions) {
    t6 = (optionTypeId_1, optionValue_2) => purchasableOptions.has(`${optionTypeId_1}:${optionValue_2}`);
    $[24] = purchasableOptions;
    $[25] = t6;
  } else {
    t6 = $[25];
  }
  const isOptionPurchasable = t6;
  let t7;
  if ($[26] !== findVariant || $[27] !== onVariantChange || $[28] !== selectedOptions) {
    t7 = (optionTypeId_2, optionValue_3) => {
      const newOptions_0 = {
        ...selectedOptions,
        [optionTypeId_2]: optionValue_3
      };
      const newVariant = findVariant(newOptions_0);
      onVariantChange(newVariant);
    };
    $[26] = findVariant;
    $[27] = onVariantChange;
    $[28] = selectedOptions;
    $[29] = t7;
  } else {
    t7 = $[29];
  }
  const handleOptionSelect = t7;
  let t8;
  if ($[30] !== optionValueDetailsMap) {
    t8 = (optionTypeId_3, optionValueName) => optionValueDetailsMap[`${optionTypeId_3}:${optionValueName}`] || null;
    $[30] = optionValueDetailsMap;
    $[31] = t8;
  } else {
    t8 = $[31];
  }
  const getOptionValueDetails = t8;
  if (optionTypes.length === 0) {
    return null;
  }
  let t9;
  if ($[32] !== getOptionValueDetails || $[33] !== handleOptionSelect || $[34] !== isOptionAvailable || $[35] !== isOptionPurchasable || $[36] !== optionTypes || $[37] !== optionValuesMap || $[38] !== selectedOptions || $[39] !== t) {
    let t10;
    if ($[41] !== getOptionValueDetails || $[42] !== handleOptionSelect || $[43] !== isOptionAvailable || $[44] !== isOptionPurchasable || $[45] !== optionValuesMap || $[46] !== selectedOptions || $[47] !== t) {
      t10 = optionType_0 => {
        const values_0 = Array.from(optionValuesMap[optionType_0.id] || []);
        const selectedValue = selectedOptions[optionType_0.id];
        const isColor = optionType_0.kind === "color_swatch";
        return <div key={optionType_0.id}><div className="flex items-center justify-between mb-3"><span className="text-sm font-medium text-gray-900">{optionType_0.label}</span>{selectedValue && <span className="text-sm text-gray-500">{getOptionValueDetails(optionType_0.id, selectedValue)?.label || selectedValue}</span>}</div>{isColor ? <div className="flex flex-wrap gap-2">{values_0.map(value_1 => {
              const optionValue_4 = getOptionValueDetails(optionType_0.id, value_1);
              const isSelected = selectedValue === value_1;
              const isAvailable = isOptionAvailable(optionType_0.id, value_1);
              const isPurchasable = isOptionPurchasable(optionType_0.id, value_1);
              return <button type="button" key={value_1} onClick={() => handleOptionSelect(optionType_0.id, value_1)} disabled={!isAvailable} title={optionValue_4?.label || value_1} className={`
                        w-10 h-10 rounded-lg border transition-all relative overflow-hidden
                        ${isSelected ? "border-gray-900 ring-2 ring-primary ring-offset-2" : "border-gray-200"}
                        ${!isAvailable ? "opacity-30 cursor-not-allowed" : "cursor-pointer"}
                        ${!isPurchasable && isAvailable ? "opacity-50" : ""}
                      `} style={optionValue_4?.image_url ? {
                backgroundImage: `url(${optionValue_4.image_url})`,
                backgroundSize: "cover"
              } : optionValue_4?.color_code ? {
                backgroundColor: optionValue_4.color_code
              } : {
                backgroundColor: "#e5e7eb"
              }}>{!isPurchasable && isAvailable && <span className="absolute inset-0 flex items-center justify-center"><span className="w-full h-0.5 bg-gray-400 rotate-45 absolute" /></span>}</button>;
            })}</div> : <div className="flex flex-wrap gap-2">{values_0.map(value_2 => {
              const optionValue_5 = getOptionValueDetails(optionType_0.id, value_2);
              const isSelected_0 = selectedValue === value_2;
              const isAvailable_0 = isOptionAvailable(optionType_0.id, value_2);
              const isPurchasable_0 = isOptionPurchasable(optionType_0.id, value_2);
              return <Button type="button" key={value_2} variant="outline" onClick={() => handleOptionSelect(optionType_0.id, value_2)} disabled={!isAvailable_0} className={isSelected_0 ? "ring-2 ring-primary ring-offset-2 border-primary" : ""}>{optionValue_5?.label || value_2}{!isPurchasable_0 && isAvailable_0 && <span className="ml-1 text-xs text-gray-400">{t("outOfStockVariant")}</span>}</Button>;
            })}</div>}</div>;
      };
      $[41] = getOptionValueDetails;
      $[42] = handleOptionSelect;
      $[43] = isOptionAvailable;
      $[44] = isOptionPurchasable;
      $[45] = optionValuesMap;
      $[46] = selectedOptions;
      $[47] = t;
      $[48] = t10;
    } else {
      t10 = $[48];
    }
    t9 = optionTypes.map(t10);
    $[32] = getOptionValueDetails;
    $[33] = handleOptionSelect;
    $[34] = isOptionAvailable;
    $[35] = isOptionPurchasable;
    $[36] = optionTypes;
    $[37] = optionValuesMap;
    $[38] = selectedOptions;
    $[39] = t;
    $[40] = t9;
  } else {
    t9 = $[40];
  }
  let t10;
  if ($[49] !== t9) {
    t10 = <div className="space-y-6">{t9}</div>;
    $[49] = t9;
    $[50] = t10;
  } else {
    t10 = $[50];
  }
  return t10;
}
function _temp2(t0) {
  const {
    variant: variant_3
  } = t0;
  return variant_3.purchasable;
}
function _temp(variant_0) {
  const optionsMap = {};
  variant_0.option_values.forEach(ov_0 => {
    optionsMap[ov_0.option_type_id] = ov_0.name;
  });
  return {
    variant: variant_0,
    optionsMap
  };
}